


































import {Component, Vue, Prop} from 'vue-property-decorator';
import {Boundaries} from '@/views/system/modules/interfaces';

@Component({})
export default class OrEnergySensor extends Vue {
  // Точность представления нецелых чисел
  protected viewRoundingAccuracy = 1;

  @Prop({required: true})
  currentValue!: number;

  @Prop({required: true})
  unit!: string;

  @Prop({required: true})
  trend!: string;

  topBoundary: number | null = null;

  bottomBoundary: number | null = null;

  @Prop({required: true})
  boundaries!: Boundaries;

  get formattedValue() {
    if (this.currentValue == null) return 'н/д';
    let val = this.currentValue;
    if (this.currentValue > 100000) val = this.currentValue / 1000;
    return val.toFixed(this.viewRoundingAccuracy);
  }

  get formattedUnit() {
    if (this.currentValue && this.currentValue > 10000) return `тыс. ${this.unit}`;
    return `${this.unit}`;
  }

  get textColor() {
    let colorText = '';
    if (
      this.currentValue &&
      this.boundaries.topErrorBoundary != null &&
      this.currentValue >= this.boundaries.topErrorBoundary
    ) {
      colorText = 'red--text';
      this.bottomBoundary = this.boundaries.topErrorBoundary;
    }
    if (
      this.currentValue &&
      this.boundaries.topErrorBoundary != null &&
      this.boundaries.topDangerBoundary != null &&
      this.currentValue < this.boundaries.topErrorBoundary &&
      this.currentValue >= this.boundaries.topDangerBoundary
    ) {
      colorText = 'orange--text';
      this.bottomBoundary = this.boundaries.topDangerBoundary;
      this.topBoundary = this.boundaries.topErrorBoundary;
    }
    if (
      this.currentValue &&
      this.boundaries.topWarningBoundary != null &&
      this.boundaries.topDangerBoundary != null &&
      this.currentValue < this.boundaries.topDangerBoundary &&
      this.currentValue >= this.boundaries.topWarningBoundary
    ) {
      colorText = 'yellow--text';
      this.bottomBoundary = this.boundaries.topWarningBoundary;
      this.topBoundary = this.boundaries.topDangerBoundary;
    }
    if (
      this.currentValue &&
      this.boundaries.topWarningBoundary != null &&
      this.boundaries.bottomWarningBoundary != null &&
      this.currentValue < this.boundaries.topWarningBoundary &&
      this.currentValue >= this.boundaries.bottomWarningBoundary
    ) {
      colorText = 'black--text';
      this.bottomBoundary = this.boundaries.bottomWarningBoundary;
      this.topBoundary = this.boundaries.topWarningBoundary;
    }
    if (
      this.currentValue &&
      this.boundaries.bottomDangerBoundary != null &&
      this.boundaries.bottomWarningBoundary != null &&
      this.currentValue < this.boundaries.bottomWarningBoundary &&
      this.currentValue >= this.boundaries.bottomDangerBoundary
    ) {
      colorText = 'cyan--text';
      this.bottomBoundary = this.boundaries.bottomDangerBoundary;
      this.topBoundary = this.boundaries.bottomWarningBoundary;
    }
    if (
      this.currentValue &&
      this.boundaries.bottomDangerBoundary != null &&
      this.boundaries.bottomErrorBoundary != null &&
      this.currentValue < this.boundaries.bottomDangerBoundary &&
      this.currentValue >= this.boundaries.bottomErrorBoundary
    ) {
      colorText = 'blue--text';
      this.bottomBoundary = this.boundaries.bottomErrorBoundary;
      this.topBoundary = this.boundaries.bottomDangerBoundary;
    }
    if (
      this.currentValue &&
      this.boundaries.bottomErrorBoundary != null &&
      this.currentValue < this.boundaries.bottomErrorBoundary
    ) {
      colorText = 'purple--text';
      this.topBoundary = this.boundaries.bottomErrorBoundary;
    }
    return colorText;
  }
}
